import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { webhooksApi } from '@/lib/api/endpoints';
import { fmtDateTime } from '@/lib/format';

export function WebhookEventsCard() {
  const q = useQuery({ queryKey: ['webhooks', 'events'], queryFn: () => webhooksApi.events(50), refetchInterval: 10_000 });
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Eventos recebidos</CardTitle>
        <CardDescription>Últimos 50 webhooks do provedor. Útil para diagnosticar assinatura inválida ou falhas de processamento.</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        {q.isLoading ? (
          <div className="space-y-2 p-4">{Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-8" />)}</div>
        ) : q.data?.length ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Recebido</TableHead>
                <TableHead>Provedor</TableHead>
                <TableHead>Evento</TableHead>
                <TableHead>Assinatura</TableHead>
                <TableHead>Processado</TableHead>
                <TableHead>Chamada</TableHead>
                <TableHead>Erro</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {q.data.map((e) => (
                <TableRow key={e.id}>
                  <TableCell className="text-xs">{fmtDateTime(e.receivedAt)}</TableCell>
                  <TableCell className="text-xs">{e.provider}</TableCell>
                  <TableCell className="font-mono text-xs">{e.eventType}</TableCell>
                  <TableCell>{e.signatureOk ? <CheckCircle2 className="size-4 text-success" /> : <XCircle className="size-4 text-destructive" />}</TableCell>
                  <TableCell>{e.processedAt ? <CheckCircle2 className="size-4 text-success" /> : <Clock className="size-4 text-muted-foreground" />}</TableCell>
                  <TableCell className="text-xs">{e.callId ? <Link className="underline" to={`/chamadas/${e.callId}`}>ver</Link> : '—'}</TableCell>
                  <TableCell className="max-w-xs truncate text-xs text-destructive">{e.error ?? ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <p className="p-6 text-sm text-muted-foreground">Nenhum evento recebido ainda.</p>
        )}
      </CardContent>
    </Card>
  );
}
